import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBillPay = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11 1.125C13.1401 1.125 14.875 2.8599 14.875 5V11C14.875 13.1401 13.1401 14.875 11 14.875H5C2.8599 14.875 1.125 13.1401 1.125 11V5C1.125 2.8599 2.8599 1.125 5 1.125H11ZM5 2.125C3.41218 2.125 2.125 3.41218 2.125 5V11C2.125 12.5878 3.41218 13.875 5 13.875H11C12.5878 13.875 13.875 12.5878 13.875 11V5C13.875 3.41218 12.5878 2.125 11 2.125H5ZM7.41699 4.46387C7.61219 4.26866 7.92875 4.26879 8.12402 4.46387L11.3018 7.64062C11.4741 7.81318 11.4927 8.07991 11.3604 8.27441C11.3412 8.3043 11.3191 8.33326 11.293 8.35938L8.11621 11.5371C7.92104 11.7319 7.60435 11.7319 7.40918 11.5371C7.21404 11.342 7.21427 11.0254 7.40918 10.8301L9.73047 8.50684C9.7127 8.50769 9.69486 8.51074 9.67676 8.51074H5.08203C4.67109 8.51074 4.33821 8.2867 4.33789 8.01074C4.33789 7.7346 4.67089 7.51075 5.08203 7.51074H9.67676C9.70587 7.51075 9.73446 7.51343 9.7627 7.51562L7.41699 5.1709C7.22205 4.97576 7.2222 4.6591 7.41699 4.46387Z",
		fill: "currentColor"
	})
});
export default SvgBillPay;
